import axiosInstance from "../../lib/axiosInstance";
import { AppDispatch } from "../store";
import { ledgerEntryActions } from "../slices/ledgerEntry";
import { getErrorMessage } from "../../utils/errorUtils";
import { LedgerEntrySummaryDto } from "../../shared/dtos/ledgerEntry/LedgerEntrySummaryDto";
import { DateRangePaginationQueryDto } from "../../shared/dtos/common/DateRangePaginationQueryDto";
import { ApiResponseDto } from "../../shared/dtos/common/ApiResponseDto";
import { PaginatedResponse } from "../../shared/dtos/common/PaginatedResponse";
import { ApiResponseStatus } from "../../shared/enums/ApiResponseStatus";

export const getLedgerEntries =
  (params?: DateRangePaginationQueryDto) =>
  async (dispatch: AppDispatch): Promise<void> => {
    dispatch(ledgerEntryActions.setLoading());
    try {
      const { data } = await axiosInstance.get<
        ApiResponseDto<PaginatedResponse<LedgerEntrySummaryDto>>
      >("/ledger-entries", {
        headers: { requiresAuth: true },
        params,
      });
      if (data.status === ApiResponseStatus.SUCCESS && data.data) {
        dispatch(ledgerEntryActions.setItems(data.data.content));
        dispatch(ledgerEntryActions.setPagination(data.data.pagination));
      }
    } catch (error) {
      dispatch(ledgerEntryActions.setError(getErrorMessage(error)));
    }
  };
